'use client'
import React from 'react';
import { LocaleContext, LocaleData } from '@/app/contexts/LocaleContext';
import WatermarkWrapper from '@/app/WatermarkWrapper';
import GPTScale from './app/GPTScale';
import KeyMetrics2026 from './app/KeyMetrics2026';
import ChinaComputeCentralization from './app/ChinaComputeCentralization';
import ComputeAllocation2024v2027 from './app/ComputeAllocation2024v2027';
import DeploymentCurves from './app/DeploymentCurves';
import PublicationDate from './app/components/PublicationDate';
import { panelData } from './panelData';

// Watermark settings mirror the English versions in app/Markdown.tsx.
const value: LocaleData = {
  locale: 'ja',
  components: {
    gptScale: WatermarkWrapper(GPTScale, 25, 30),
    keyMetrics2026: WatermarkWrapper(KeyMetrics2026, 25, 50),
    chinaComputeCentralization: WatermarkWrapper(ChinaComputeCentralization),
    ComputeAllocation2024v2027: WatermarkWrapper(ComputeAllocation2024v2027),
    DeploymentCurves: WatermarkWrapper(DeploymentCurves),
    publicationDate: PublicationDate,
  },
  panelData,
};

export default function LocaleProvider({ children }: { children: React.ReactNode }) {
  // lang is set here rather than on <html> so the CJK font stack in
  // app/globals.css applies on first paint; SetHtmlLang still corrects the
  // document language for assistive tech and SEO.
  return (
    <LocaleContext.Provider value={value}>
      <div lang="ja" className="contents">{children}</div>
    </LocaleContext.Provider>
  );
}
